import { render, staticRenderFns } from "./WearehouseManagement.vue?vue&type=template&id=32ac8834&scoped=true&"
import script from "./WearehouseManagement.vue?vue&type=script&lang=js&"
export * from "./WearehouseManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ac8834",
  null
  
)

export default component.exports